import _ from "lodash";
import {useSelector} from "react-redux";
import {messageDirection, msgSource} from "_constants";
import {isReviewed} from "./MessageActionUtils";
import {getPlatform, PLATFORM} from "../../../Utilities/MessageDetailsUtils";

export class MessageActionEvaluator {
    constructor(message) {
        this.message = message;
    }

    isDeleteFromSourceSupported() {
        return _.get(this, 'message.teamsAttributes.canBeDeletedFromSource') ||
        _.get(this, 'message.canBeDeletedFromSource');
    }

    isMessageActioned() {
         return _.get(this, 'message.actioned') || _.get(this, 'message.userMessageActions.length') > 0;
    }

    isBlacklistPostSupported() {
        return _.toString(_.get(this, 'message.sourceName')).toLowerCase() === msgSource.FACEBOOK ||
        _.toString(_.get(this, 'message.sourceName')).toLowerCase() === msgSource.INSTAGRAM;
    }

    isHideSupported() {
        const canBeHidden = _.get(this, 'message.teamsAttributes.canBeHidden') || _.get(this, 'message.canBeHidden');
        return canBeHidden && !_.get(this, 'message.isHidden');
    }

    hideStatus() {
        return _.get(this, 'message.hiddenFromSource');
    }

    isLikeSupported() {
        return _.get(this, 'message.teamsAttributes.canBeLiked') ||
            _.get(this, 'message.canBeLiked');
    }

    isPriorityForPracticeSupported() {
        const platform = getPlatform(_.get(this, 'message.id'));
        return platform === PLATFORM.TEAMS &&
            _.get(this, 'message.direction') === messageDirection.INCOMING;
    }

    priorityForPracticeStatus() {
        const isMessageReviewed = _.get(this, 'message.isReviewed');
        const updatedIsReviewed = useSelector(state => state.messages.updatedIsReviewed);
        return isReviewed(isMessageReviewed, updatedIsReviewed);
    }

    isSupported() {
        return true;
    }

    isActive() {
        return true;
    }

    evaluate(message) {
        const predicateMethod = message.predicate;
        const switchValueMethod = message.switchValue;
        const methodResult = this[predicateMethod?.replace('!', '')]?.call(this);
        const switchValueResult = switchValueMethod ? this[switchValueMethod?.replace('!', '')]?.call(this) : false;
        return (methodResult ^ predicateMethod?.startsWith('!')) && (switchValueMethod?.startsWith('!') ? !switchValueResult : switchValueResult);
    }
}
